import React, { useState } from "react";
import { Link } from "react-router-dom";
import RisenLogo from "../../images/risenstar.png";
import "./Navbar.css";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to={"/"} className="logo-link" onClick={closeMenu}>
          <div className="logo">
            <img src={RisenLogo} alt="Risen Star Goods" />
            <p>Risen Star Goods</p>
          </div>
        </Link>

        {/* Hamburger Menu Button */}
        <button
          className={`hamburger ${isMenuOpen ? "hamburger--active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Links */}
        <div className={`nav-menu ${isMenuOpen ? "nav-menu--active" : ""}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={closeMenu}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/products" onClick={closeMenu}>
                Products
              </Link>
            </li>
            <li>
              <Link to="/delivery" onClick={closeMenu}>
                Delivery
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Overlay when menu is open */}
        {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
      </div>
    </nav>
  );
}
